/**
 * 限制图片上传比例 限制为750:400
 * @param {object} file - 上传的图片对象 
 * @param {window} self  - this指向
 */
const imgSize = (file, self) => {
  return new Promise((resolve, reject) => {
    let url = window.URL || window.webkitURL;
    let img = new Image();
    img.onload = function () {
      // 图片比例校验
      let valid = (img.width / img.height).toFixed(3) == 1.875;
      valid ? resolve() : reject();
    };
    img.src = url.createObjectURL(file);
  }).then(
    () => {
      return file;
    },
    () => {
      self.$message.error("上传的图片建议比例750:400");
      return Promise.reject("尺寸不对");
    }
  );
}

export default imgSize;